import React from "react";
import { Link, useParams } from "react-router-dom";
import Layouts from "../../config/layouts/Layouts";
import NavbarComponent from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import { AUTHORITY_PAGES, CASE_STUDIES } from "../../data/authorityPages";
import Error404 from "../errors/Error404";

function AuthorityContent({ page }) {
    return (
        <main className="min-h-screen bg-em-bg pb-[calc(7rem+var(--em-footer-h))] pt-32 text-em-text sm:pt-36 md:pt-40">
            <div className="mx-auto max-w-5xl px-5 md:px-8">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-em-accent">{page.eyebrow}</p>
                <h1 className="mt-4 max-w-4xl text-4xl font-black tracking-tight md:text-6xl">{page.title}</h1>
                <p className="mt-7 max-w-3xl text-lg leading-8 text-em-soft md:text-xl">{page.lead}</p>

                <div className="mt-14 grid gap-4 md:grid-cols-3">
                    {page.sections.map(([title, body]) => (
                        <section key={title} className="rounded-2xl border border-em-text/10 bg-em-card p-6">
                            <h2 className="text-xl font-extrabold text-em-text">{title}</h2>
                            <p className="mt-3 leading-7 text-em-soft">{body}</p>
                        </section>
                    ))}
                </div>

                {page.sources?.length ? (
                    <section className="mt-14 border-y border-em-text/10 py-8" aria-labelledby="authority-sources">
                        <p className="text-xs font-bold uppercase tracking-[0.2em] text-em-accent2">Evidencia</p>
                        <h2 id="authority-sources" className="mt-3 text-2xl font-black">Fuentes primarias y documentación oficial</h2>
                        <ul className="mt-5 space-y-3">
                            {page.sources.map(([title, url]) => (
                                <li key={url}><a className="font-semibold text-em-accent hover:text-em-accent2" href={url} target="_blank" rel="noopener noreferrer">{title} ↗</a></li>
                            ))}
                        </ul>
                    </section>
                ) : null}

                <div className="mt-12 flex flex-wrap gap-3">
                    <Link to="/ia-aviacion-seguridad-operacional" className="btn-secondary">Ver especialidad aeronáutica</Link>
                    <Link to="/contacto" className="btn-primary">Evaluar un caso de uso</Link>
                </div>
            </div>
        </main>
    );
}

export function KnowledgePage() {
    const { slug } = useParams();
    return <PageShell page={AUTHORITY_PAGES[slug]} />;
}

export function CaseStudyPage() {
    const { slug } = useParams();
    return <PageShell page={CASE_STUDIES[slug]} />;
}

function PageShell({ page }) {
    if (!page) return <Error404 />;
    return (
        <Layouts>
            <header><NavbarComponent /></header>
            <AuthorityContent page={page} />
            <Footer />
        </Layouts>
    );
}
